export default __webpack_public_path__ + "static/media/uniforme-policia-hombre.07b72ac5.png";